
import router from '@/router'
import store from '@/store'
import moment from 'moment'
import { iconList, iconMapping } from '@/views/dashboard/board-management/compoents/icon'
function setDirectivesData(item) {
  return [
    {
      name: 'authority',
      value: { ...item }
    }
  ]
}
function getTextStyle(item) {
  if (item.color) {
    return { color: item.color }
  }
  return {}
}
function getRenderTitle(h, item, props, spanSlot = false) {
  const { iconKey, titleKey, translate } = props
  const children = [
    h('i', {
      class: ['iconfont', iconMapping(item[iconKey]), 'h-menu-title '],
      style: getTextStyle(item)
    }),
    h(
      'span',
      {
        style: getTextStyle(item),
        class: ['h-menu-title'],
        ...(spanSlot ? { slot: 'title' } : {})
      },
      [
        translate(item['actionCode'] && 'menu::' + item['actionCode'].split('::').slice(1).join('::'))
      ]
    )
  ].filter(Boolean)
  return children
}
function renderItem(h, item, props) {
  const { pathKey, nameKey, translate } = props
  let itemChildren = []
  const itemProps = {
    index: (item.url.includes('data-board') || item.url.includes('iframe-board')) ? item[nameKey] : item.url.split('?')[0]
  }

  // if (item[pathKey]) {
  //   itemChildren = [
  //     h(
  //       'router-link',
  //       {
  //         slot: 'title',
  //         props: {
  //           to: item[nameKey]
  //         }
  //       },
  //       getRenderTitle(h, item, props)
  //     )
  //   ]
  // } else {
  itemChildren = getRenderTitle(h, item, props, true)
  // if (item.url) {
  //   itemProps.route = { path: item.url }
  // } else {
  //   itemProps.route = { name: item[nameKey] }
  // }
  // itemProps.route = { name: item[nameKey] }

  // }
  return item.isShow && item.actionType === 1 ? h(
    'el-menu-item',
    {
      // 如果是平台看板，则剪切url
      key: (item.url.includes('data-board') || item.url.includes('iframe-board')) && item.url.split('?').length ? item[nameKey] : item.url.split('?')[0],
      props: itemProps,
      on: {
        click: (e) => {
          // 菜单项都是报表，直接点击上报
          if (item.boardType) {
            store.dispatch('buried', {
              event: 'dataKanbanUsesStatistics',
              dataKanbanName: item.actionName,
              clickTime: moment(Date.now()).format('YYYY-MM-DD HH:MM:SS'),
              kanbanType: item.openType === 1 ? '第三方链接' : item.openType == 2 ? '平台看板' : '空白看板',
              kanbanSource: item.boardType == 1 ? '公共看板' : '个人看版'
            })
          }
          if (item.url) {
            // 判断页面打开方式
            if (item.openTarget === 1) {
              router.push({ path: item.url })
            } else {
              window.open(window.location.origin + item.url, '_blank')
            }
          } else {
            router.push({ name: item.actionCode.split('::').pop() })
          }
        }
      }
      // directives: setDirectivesData(item)
    },
    itemChildren
  ) : h()
}
function renderMenuItem(h, item, props) {
  const { childKey, nameKey } = props
  if (!item[childKey] || !item[childKey].length) {

    return renderItem(h, item, props)
  }
  const title = getRenderTitle(h, item, props)
  const children = item[childKey].filter(item => item.isShow && item.actionType === 1).map(i => renderMenuItem(h, i, props))
  if (!children.length) {
    return renderItem(h, item, props)
  }
  return item.isShow && item.actionType === 1 ? h(
    'el-submenu',
    {
      key: item[nameKey],
      props: {
        index: item[nameKey],
        popperClass: 'h-menu-poppe'
      }
      // directives: setDirectivesData(item)
    },
    [
      h(
        'div',
        {
          slot: 'title'
        },
        title
      ),
      ...children
    ]
  ) : h()
}
export default {
  functional: true,
  props: {
    childKey: {
      type: String,
      default: 'children'
    },
    nameKey: {
      type: String,
      default: 'name'
    },
    titleKey: {
      type: String,
      default: 'title'
    },
    pathKey: {
      type: String,
      default: 'url'
    },
    iconKey: {
      type: String,
      default: 'icon'
    },
    translate: {
      default: () => null
    },
    item: {
      type: Object,
      required: true
    }
  },
  mounted() {
  },
  render(h, { props }) {

    return renderMenuItem(h, props.item, props)
  },
  methods: {
    iconMapping
  }
}
